export const ACTION_SET_CONFIRM = 'SET_CONFIRM';
export const setConfirm=(info)=>{
    return {
        type:ACTION_SET_CONFIRM,
        payload:info
    }
}